import { render, staticRenderFns } from "./UtilLoader.vue?vue&type=template&id=22baa700&scoped=true&"
import script from "./UtilLoader.vue?vue&type=script&lang=js&"
export * from "./UtilLoader.vue?vue&type=script&lang=js&"
import style0 from "./UtilLoader.vue?vue&type=style&index=0&id=22baa700&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22baa700",
  null
  
)

export default component.exports